// ================================================================
// NOTIFICATIONS.JS - Sistema de Notificações Operacional
// ================================================================

window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages = window.FazendaRP.Pages || {};
window.FazendaRP.Pages.operacional = window.FazendaRP.Pages.operacional || {};

window.FazendaRP.Pages.operacional.notifications = {
    cache: [],
    unreadCount: 0,

    /**
     * Buscar notificações pendentes
     */
    async fetch() {
        try {
            const notifications = [];
            const today = new Date();
            const tomorrow = new Date(today);
            tomorrow.setDate(tomorrow.getDate() + 1);
            const nextWeek = new Date(today);
            nextWeek.setDate(nextWeek.getDate() + 7);

            // Formato YYYY-MM-DD
            const todayStr = today.toISOString().split('T')[0];
            const tomorrowStr = tomorrow.toISOString().split('T')[0];
            const nextWeekStr = nextWeek.toISOString().split('T')[0];

            // 1. PRESCRIÇÕES PRÓXIMAS (Próximos 7 dias)
            const { data: prescricoes } = await window.FazendaRP.supabase
                .from('operacional_prescricoes')
                .select('*')
                .gte('data_inicio', todayStr)
                .lte('data_inicio', nextWeekStr)
                .order('data_inicio', { ascending: true });

            if (prescricoes && prescricoes.length > 0) {
                prescricoes.forEach(p => {
                    const dataInicio = new Date(p.data_inicio + 'T00:00:00');
                    const diffDays = Math.ceil((dataInicio - today) / (1000 * 60 * 60 * 24));

                    let urgency = 'normal';
                    let icon = 'calendar-check';
                    let color = '#3b82f6';

                    if (diffDays === 0) {
                        urgency = 'high';
                        icon = 'exclamation-circle';
                        color = '#ef4444';
                    } else if (diffDays === 1) {
                        urgency = 'medium';
                        icon = 'clock';
                        color = '#f59e0b';
                    }

                    notifications.push({
                        id: `prescricao-${p.id}`,
                        type: 'prescricao',
                        urgency,
                        icon,
                        color,
                        title: `Prescrição: ${p.nome}`,
                        message: diffDays === 0 ? 'Programada para HOJE' :
                            diffDays === 1 ? 'Programada para AMANHÃ' :
                                `Em ${diffDays} dias`,
                        date: p.data_inicio,
                        link: () => {
                            window.FazendaRP.Pages.operacional.core.showTab('prescricoes');
                        }
                    });
                });
            }

            // 2. ATIVIDADES VENCIDAS (não concluídas)
            // (Assumindo que atividades sem data_fim são pendentes)
            const { data: atividades } = await window.FazendaRP.supabase
                .from('operacional_atividades')
                .select('*')
                .is('data_fim', null)
                .lt('data_atividade', todayStr)
                .order('data_atividade', { ascending: true })
                .limit(10);

            if (atividades && atividades.length > 0) {
                atividades.forEach(a => {
                    const dataAtividade = new Date(a.data_atividade + 'T00:00:00');
                    const diffDays = Math.ceil((today - dataAtividade) / (1000 * 60 * 60 * 24));

                    notifications.push({
                        id: `atividade-${a.id}`,
                        type: 'atividade_atrasada',
                        urgency: 'high',
                        icon: 'exclamation-triangle',
                        color: '#dc2626',
                        title: `Atividade Pendente: ${a.tipo_operacao}`,
                        message: `Atrasada há ${diffDays} dia${diffDays > 1 ? 's' : ''}`,
                        date: a.data_atividade,
                        link: () => {
                            window.FazendaRP.Pages.operacional.core.showTab('diario');
                        }
                    });
                });
            }

            // 3. ALERTAS GERAIS (exemplo: clima, etc)
            // Placeholder para expansão futura

            this.cache = notifications;
            this.unreadCount = notifications.length;

            return notifications;

        } catch (err) {
            console.error('Erro ao buscar notificações:', err);
            return [];
        }
    },

    /**
     * Renderizar badge de contador
     */
    renderBadge(count) {
        if (count === 0) return '';

        return `
            <span style="position:absolute; top:-5px; right:-5px; background:#ef4444; color:white; 
                         font-size:0.7rem; font-weight:700; padding:2px 6px; border-radius:10px; 
                         box-shadow:0 2px 4px rgba(239,68,68,0.4);">
                ${count > 9 ? '9+' : count}
            </span>
        `;
    },

    /**
     * Abrir modal de notificações
     */
    async openModal() {
        const notifications = await this.fetch();

        const html = `
            <div id="notifications-modal" style="position:fixed; top:0; left:0; right:0; bottom:0; 
                                                  background:rgba(0,0,0,0.5); z-index:9999; display:flex; 
                                                  align-items:flex-start; justify-content:flex-end; 
                                                  padding:20px;" 
                 onclick="if(event.target.id === 'notifications-modal') this.remove();">
                
                <div style="background:white; width:100%; max-width:400px; max-height:80vh; 
                           border-radius:12px; box-shadow:0 10px 25px rgba(0,0,0,0.2); 
                           overflow:hidden; display:flex; flex-direction:column;" 
                     onclick="event.stopPropagation();">
                    
                    <!-- Header -->
                    <div style="background:linear-gradient(135deg, #059669, #047857); color:white; 
                               padding:20px; display:flex; justify-content:space-between; align-items:center;">
                        <div>
                            <h3 style="margin:0; font-size:1.2rem;">
                                <i class="fas fa-bell"></i> Notificações
                            </h3>
                            <p style="margin:5px 0 0 0; font-size:0.85rem; opacity:0.9;">
                                ${notifications.length} alerta${notifications.length !== 1 ? 's' : ''} pendente${notifications.length !== 1 ? 's' : ''}
                            </p>
                        </div>
                        <button onclick="document.getElementById('notifications-modal').remove()" 
                                style="background:rgba(255,255,255,0.2); border:none; color:white; 
                                       width:30px; height:30px; border-radius:50%; cursor:pointer; 
                                       font-size:1.2rem;">
                            ×
                        </button>
                    </div>

                    <!-- Lista -->
                    <div style="flex:1; overflow-y:auto; padding:15px;">
                        ${notifications.length === 0 ? `
                            <div style="text-align:center; padding:40px 20px; color:#9ca3af;">
                                <i class="fas fa-check-circle" style="font-size:3rem; color:#10b981; margin-bottom:15px;"></i>
                                <p style="font-size:1rem; font-weight:600; color:#6b7280; margin:0;">Tudo em dia!</p>
                                <p style="font-size:0.85rem; margin:5px 0 0 0;">Nenhuma notificação pendente.</p>
                            </div>
                        ` : notifications.map(n => `
                            <div style="background:${n.urgency === 'high' ? '#fef2f2' : n.urgency === 'medium' ? '#fffbeb' : '#f0f9ff'}; 
                                        border-left:4px solid ${n.color}; padding:15px; border-radius:8px; 
                                        margin-bottom:10px; cursor:pointer; transition:transform 0.2s, box-shadow 0.2s;"
                                 onmouseover="this.style.transform='translateX(5px)'; this.style.boxShadow='0 2px 8px rgba(0,0,0,0.1)';"
                                 onmouseout="this.style.transform='translateX(0)'; this.style.boxShadow='none';">
                                
                                <div style="display:flex; align-items:start; gap:12px;">
                                    <i class="fas fa-${n.icon}" style="color:${n.color}; font-size:1.2rem; margin-top:2px;"></i>
                                    <div style="flex:1;">
                                        <div style="font-weight:600; color:#1f2937; font-size:0.95rem; margin-bottom:3px;">
                                            ${n.title}
                                        </div>
                                        <div style="font-size:0.85rem; color:#6b7280;">
                                            ${n.message}
                                        </div>
                                        ${n.date ? `
                                            <div style="font-size:0.75rem; color:#9ca3af; margin-top:5px;">
                                                <i class="fas fa-calendar"></i> ${new Date(n.date + 'T00:00:00').toLocaleDateString('pt-BR')}
                                            </div>
                                        ` : ''}
                                    </div>
                                </div>
                            </div>
                        `).join('')}
                    </div>

                    <!-- Footer -->
                    <div style="background:#f9fafb; padding:15px; border-top:1px solid #e5e7eb; text-align:center;">
                        <button onclick="window.FazendaRP.Pages.operacional.notifications.fetch(); this.innerHTML='<i class=\\'fas fa-check\\'></i> Atualizado!'; setTimeout(() => this.innerHTML='<i class=\\'fas fa-sync\\'></i> Atualizar', 2000);"
                                style="background:white; border:1px solid #d1d5db; color:#6b7280; 
                                       padding:8px 16px; border-radius:6px; cursor:pointer; font-weight:600; 
                                       font-size:0.85rem;">
                            <i class="fas fa-sync"></i> Atualizar
                        </button>
                    </div>
                </div>
            </div>
    `;

        document.body.insertAdjacentHTML('beforeend', html);
    }
};
